module.exports = __webpack_public_path__ + "img/applets1icon1.173947db.png";